import React, {useState} from "react";
import styled from "styled-components";
import { useForm } from "react-hook-form";

import Logo from "../Components/Logo";
import AuthContainer from "../Components/Auth/Container";
import Input from "../Components/Form/Input";
import Button from "../Components/Form/Button";
import ButtonLink from "../Components/Form/ButtonLink";
import OrWrapper from "../Components/Form/OrWrapper";
import Auth from "../Layouts/Auth";
import ElementWrapper from "../Components/Form/ElementWrapper";
import { Helmet } from "react-helmet-async";
import Form from "../Components/Auth/Form";
import { useHistory } from 'react-router-dom';
import { log_in } from '../../util/auth'
import api from '../../util/api';
import MainWrapper from "../Components/Main/MainWrapper";

const Error = styled.div`
    position: relative;
    padding: .75rem 1.25rem;
    margin-bottom: 1rem;
    border: 1px solid transparent;
    border-radius: .25rem;
    color: #721c24;
    background-color: #f8d7da;
    border-color: #f5c6cb;
`;

const ForgotPassword = styled.a`
    text-align: center;  
    width: 100%;
    display: block;
`;

const Login = () => {
    const { register, handleSubmit, errors } = useForm();
    const [formError, setFormError] = useState(null);
    const history = useHistory();
    const onSubmit = (data) => {
        api(true).get('/sanctum/csrf-cookie').then(() => {
            api(true).post('/fortify/login', {
                email: data.email,
                password: data.password
            }).then(() => {
                log_in();
            }).catch((error) => {
                if(error.errors) {
                    setFormError(error.errors.toString());
                }
            });
        });
    };

    return (
        <MainWrapper>
            <Auth>
                <Helmet>
                    <title>Login - MUZE</title>
                </Helmet>
                <Logo />
                <br/>
                <AuthContainer>
                    {formError !== null ? (<Error>{formError}</Error>) : ('')}

                    <Form onSubmit={handleSubmit(onSubmit)}>
                        <ElementWrapper>
                            <Input
                                id="email"
                                label="Email"
                                type="email"
                                ref={register({
                                    required: {
                                        value: true,
                                        message: "Email is Required",
                                    },
                                })}
                                errors={errors.email}
                                autocomplete='email'
                            />
                        </ElementWrapper>
                        <ElementWrapper>
                            <Input
                                id="password"
                                label="Password"
                                type="password"
                                ref={register({
                                    required: {
                                        value: true,
                                        message: "Password is Required",
                                    },
                                })}
                                errors={errors.password}
                                autocomplete='current-password'
                            />
                        </ElementWrapper>
                        <ElementWrapper>
                            <Button>Login</Button>
                        </ElementWrapper>
                        <ForgotPassword href="/password/reset">Forgot Password?</ForgotPassword>
                        <OrWrapper>OR</OrWrapper>
                        <ButtonLink href="/register">Register as Instructor</ButtonLink>
                    </Form>
                </AuthContainer>
            </Auth>
        </MainWrapper>
    );
};

export default Login;
